import { s as _objectWithoutProperties, R as React } from './index-7f694484.js';
import IMaskMixin from './mixin.js';

var _excluded = ["inputRef"];

var InputComponent = function InputComponent(_ref) {
  var inputRef = _ref.inputRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return React.createElement('input', Object.assign({}, props, {
    ref: inputRef
  }));
};

var IMaskInput = IMaskMixin(InputComponent);

export { IMaskInput as default };
